import HTTP from '../libs/HTTP';

//query接口请求参数
export interface ContactQueryByIdParam {
    id: number;
}
export interface ContactQueryParam {
    id?: number,
    company?: number,
    customer?: number,
    sales?: number,
    way?: number,
    beginTime?: string,
    endTime?: string,
}
export interface ContactListRequest {
    contactQueryParam: ContactQueryParam,
    pageNo: number,
    pageSize: number,
}

//query接口返回参数
export interface IContactInfoList {
    records: IContactInfo[],
    total: number,
    size: number,
    current: number,
    pages: number,
}
export interface IContactInfo {
    id: number,
    salesName: string,
    company: number,
    companyName: string,
    customer: number, 
    customerName: string, 
    sales: number, 
    time: number, 
    tools?: string | null, 
    way?: number | null, 
    requirement?: string | null,
    content: string,
    remark?: string | null, 
}

//add接口请求参数
export interface ContactPostParam {
    company: string,
    customer: number,  
    time: number, 
    tools?: string | null, 
    way?: number, 
    requirement?: string | null,
    content: string,
    remark?: string | null, 
}

//edit接口请求参数
export interface ContactPutParam {
    id: number,
    customer: number, 
    time: number, 
    tools?: string | null, 
    way?: number | null, 
    content: string,
    remark?: string | null, 
}


class ContactService extends HTTP {
    //根据条件查询客户沟通信息
    async getCustomerContactListInfo(request: ContactListRequest) {
        const response = await this.post('/contact/getCustomerContact', request.contactQueryParam, {
            params: {
                pageNo: request.pageNo,
                pageSize: request.pageSize,
            },
        });
        if (response) {
            return response.data;
        }
    }

        //查询当前登录用户的客户沟通信息
        async getMyCustomerContactListInfo(request: ContactListRequest) {
            const response = await this.post('/contact/getCustomerContactByLoginAccount', request.contactQueryParam, {
                params: {
                    pageNo: request.pageNo,
                    pageSize: request.pageSize,
                },
            });
            if (response) {
                return response.data;
            }
        }

    //根据条件查询需求沟通信息
    async getRequirementContactListInfo(request: ContactListRequest) {
        const response = await this.post('/contact/getRequirementContact', request.contactQueryParam, {
            params: {
                pageNo: request.pageNo,
                pageSize: request.pageSize,
            },
        });
        if (response) {
            return response.data;
        }
    }

    //根据公司id查询客户沟通信息
    async getContactInfoByCompanyId(companyId: number) {
        const response = await this.post(`/contact/getCustomerContactByCompanyId/${companyId}`);
        if (response && response.data) {
            return response.data;
        }
    }

    // //根据需求id查询客户沟通信息
    // async getRequirementContactByRequirementId(requirementId: number) {
    //     const response = await this.post(`/contact/getRequirementContactByRequirementId/${requirementId}`);
    //     if (response && response.data) {
    //         return response.data;
    //     }
    // }

    //根据id查询客户沟通信息
    async getContactInfoById(id: number) {
        const response = await this.get(`/contact/getContactById/${id}`);
        if (response && response.data) {
            return response.data;
        }
    }

    //添加客户沟通信息
    async addContact(request: ContactPostParam) {
        const response = await this.post('/contact/addContact', request, {
            params: {
                company: request.company,
                customer: request.customer,
                time: request.time,
                tools: request.tools, 
                way: request.way, 
                requirement: request.requirement, 
                content: request.content,
                remark: request.remark, 
            },
        });
        if (response) {
            return response.data;
        }
    }

    //编辑客户沟通信息
    async updateContact(request: ContactPutParam) {
        const response = await this.put(`/contact/updateContact/${request.id}`, request, {
            params: {
                customer: request.customer,
                time: request.time,
                tools: request.tools, 
                way: request.way, 
                content: request.content,
                remark: request.remark, 
            },
        });
        if (response) {
            return response.data;
        }
    }

}
export default new ContactService();
